import { ref, computed } from 'vue'
import { changelog, APP_VERSION } from '@/data/changelog'

// Singleton: la última versión vista se comparte entre Sidebar, Dashboard y la vista de historial.
const STORAGE_KEY = 'app_last_seen_version'

function readLastSeen() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (_) {
    return null
  }
}

const lastSeenVersion = ref(readLastSeen())

export function useAppUpdates() {
  const entries = changelog
  const latestEntry = computed(() => changelog[0] || null)
  const latestVersion = APP_VERSION

  // Hay novedad si el bundle trae una versión distinta de la última que el usuario ya vio.
  // Con auto-update el SW ya recargó: comparar versiones es la señal correcta, no el evento del SW.
  const hasUnseenUpdate = computed(() => {
    if (!latestEntry.value) return false
    return lastSeenVersion.value !== latestVersion
  })

  function markUpdatesSeen() {
    lastSeenVersion.value = latestVersion
    try {
      localStorage.setItem(STORAGE_KEY, latestVersion)
    } catch (_) {
      // localStorage puede fallar en modo privado; el badge simplemente seguirá visible.
    }
  }

  return { entries, latestEntry, latestVersion, hasUnseenUpdate, markUpdatesSeen }
}
